"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var msal_browser_1 = require("@azure/msal-browser");
var msal_react_1 = require("@azure/msal-react");
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var user_1 = require("../../../api/user");
var authConfig_1 = require("../../../authConfig");
var graph_1 = require("../../../graph");
var AddUserModal = function (props) {
    var buttonLabel = props.buttonLabel, className = props.className;
    var _a = react_1.useState(props.companyId), companyId = _a[0], setCompanyId = _a[1];
    var _b = react_1.useState(''), newEmail = _b[0], setNewEmail = _b[1];
    var _c = msal_react_1.useMsal(), instance = _c.instance, accounts = _c.accounts;
    var _d = react_1.useState(false), isAuthorizedSuperAdmin = _d[0], setIsAuthorizedSuperAdmin = _d[1];
    var _e = react_1.useState({ id: "" }), graphData = _e[0], setGraphData = _e[1];
    var _f = react_1.useState(''), userName = _f[0], setUserName = _f[1];
    var _g = react_1.useState(false), modal = _g[0], setModal = _g[1];
    var toggle = function () { return setModal(!modal); };
    var submitAddUser = function () {
        user_1.addUser(newEmail).then(function (response) {
            props.modalCallback(response);
        });
        toggle();
    };
    var setFormChange = function (e, field) {
        var inputEmail = newEmail;
        inputEmail = e.target.value;
        /*console.log(inputEmail);*/
        setNewEmail(inputEmail.toString());
        console.log(newEmail);
    };
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var requestProfileData = function () {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent(__assign(__assign({}, authConfig_1.loginRequest), { account: accounts[0] })).then(function (response) {
            graph_1.callMsGraph("GET", response.accessToken, authConfig_1.graphConfig.graphMeEndpoint).then(function (response) {
                setGraphData(response);
                console.log(response);
                setUserName(response.mailNickname);
            });
        });
    };
    var checkIfSuperAdmin = function () {
        var currentAccount = instance.getActiveAccount();
        if (currentAccount && currentAccount.idTokenClaims) {
            var tokenClaims = currentAccount.idTokenClaims['roles'];
            console.log('token');
            console.log(tokenClaims);
            var intersection = tokenClaims.includes(authConfig_1.appRoles.SuperAdmin);
            if (intersection) {
                setIsAuthorizedSuperAdmin(true);
            }
        }
    };
    var onLoad = function () {
        requestProfileData();
        checkIfSuperAdmin();
    };
    react_1.useEffect(function () {
        if (props.companyId != null) {
            onLoad();
        }
    }, [instance]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement(reactstrap_1.Button, { color: "secondary", onClick: toggle },
                React.createElement("a", { className: "padding-default" }, "+ New User")),
            React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
                React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "+ New User"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement(reactstrap_1.Form, null,
                        React.createElement(reactstrap_1.Row, { form: true },
                            React.createElement(reactstrap_1.Col, { md: 6 },
                                React.createElement(reactstrap_1.FormGroup, null,
                                    React.createElement(reactstrap_1.Label, { for: "Email" }, "Email*"),
                                    React.createElement(reactstrap_1.Input, { type: "text", name: "Email", id: "Email", placeholder: "Enter Email", onChange: function (e) { return setFormChange(e, 'email'); } })))))),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { type: "button", color: "secondary", onClick: function () { return submitAddUser(); } }, "Confirm"))))));
};
exports.default = AddUserModal;
//# sourceMappingURL=AddUserModal.js.map